import type { CSSProperties } from "react";
import { tokens } from "@fluentui/react-components";

// Shared by the plain <table>-based pages that don't use MasterDataTable/
// material-react-table (e.g. TransactPage, FrnDetails) — was previously
// copied verbatim into each page.
const P = "16px";
const EDGE = "32px";
const V = "10px";

export function simpleTableCellStyle(first?: boolean, last?: boolean, header?: boolean): CSSProperties {
  return {
    padding: `${V} ${last ? EDGE : P} ${V} ${first ? EDGE : P}`,
    textAlign: "left",
    fontWeight: header ? 700 : undefined,
    borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
    fontSize: "14px",
    verticalAlign: "middle",
  };
}
